import { render } from "./MuxVideo.vue?vue&type=template&id=50cc4ab3&scoped=true&ts=true"
import script from "./MuxVideo.vue?vue&type=script&lang=ts"
export * from "./MuxVideo.vue?vue&type=script&lang=ts"

import "./MuxVideo.vue?vue&type=style&index=0&id=50cc4ab3&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc4ab3"]])

export default __exports__